import api from '@/services/api';
import type { PlanPhase, PlanResult, SavedPlan } from '../types';

const BASE = '/cost-simulator/plans';

async function list(): Promise<SavedPlan[]> {
  const res = await api.get<{ success: boolean; plans: SavedPlan[] }>(BASE);
  return res.data.plans;
}

async function create(name: string, phases: PlanPhase[]): Promise<SavedPlan> {
  const res = await api.post<{ success: boolean; plan: SavedPlan }>(BASE, { name, phases });
  return res.data.plan;
}

async function update(id: string, name: string, phases: PlanPhase[]): Promise<SavedPlan> {
  const res = await api.put<{ success: boolean; plan: SavedPlan }>(`${BASE}/${id}`, { name, phases });
  return res.data.plan;
}

async function remove(id: string): Promise<void> {
  await api.delete(`${BASE}/${id}`);
}

async function calculate(phases: PlanPhase[]): Promise<PlanResult> {
  const res = await api.post<{ success: boolean; result: PlanResult }>(`${BASE}/calculate`, { phases });
  return res.data.result;
}

export const planService = { list, create, update, remove, calculate };
